import { render, staticRenderFns } from "./TwPermitUpload.vue?vue&type=template&id=6f62c8b8&scoped=true&"
import script from "./TwPermitUpload.vue?vue&type=script&lang=js&"
export * from "./TwPermitUpload.vue?vue&type=script&lang=js&"
import style0 from "./TwPermitUpload.vue?vue&type=style&index=0&id=6f62c8b8&lang=scss&scoped=true&"
import style1 from "./TwPermitUpload.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f62c8b8",
  null
  
)

export default component.exports